import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { EVENT_KEY } from './keys';
import { EnrollApi } from 'api';

function useGetAllByEventId(eventId: number, participantsOnly?: boolean) {
  return useAuthQuery(
    getQueryKeys(EVENT_KEY).list({ eventId, participantsOnly }),
    () => EnrollApi.getAllByEventId(eventId, participantsOnly),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAllByEventId;
